import React from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  paddingBottom: 0,
  paddingTop: theme.spacing(1),
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  marginTop: 8,
  maxHeight: 150,
  overflow: 'auto',
  backgroundColor: getPageBackgroundColor(theme)
}));
function SuggestionPaper({ children }) {
  return <StyledPaper>{children}</StyledPaper>;
}

SuggestionPaper.propTypes = {
  children: CHILDREN_PROP_TYPES
};

export default SuggestionPaper;
